import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getSocket } from '../socket';
import { playSound } from '../utils/soundAlerts';
import API from '../api';

// ── 근로계약(전자) 서명요청 실시간 알림 모달 ──────────────────────────────
// 인사관리(HRManagement.js) 인사기록카드 > 근로계약(전자)에서 관리자가 "서명요청" 버튼을
// 누르면(backend/routes/hr.js의 POST /employees/:userId/labor-contract/:id/request-signature
// 가 'hr:labor-contract:sign-request' 이벤트를 대상 직원의 개인 소켓 room(user:<아이디>)으로
// 쏴준다), 지금 어느 화면을 보고 있든 바로 모달로 알려준다. HrInfoRequestAlert.js와 동일한 패턴.
//
// 요청 시점에 로그인되어 있지 않았던 경우를 위해, 마운트 시
// GET /mypage/labor-contract/pending-signature 으로 미확인(서명대기중) 계약서가 있는지도
// 한 번 확인한다(다음 로그인 시 알림이 뜨도록).
export default function LaborContractSignAlert() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [incoming, setIncoming] = useState(null); // { id, requested_by, target_name, ... }

  useEffect(() => {
    if (!user) return;
    API.get('/mypage/labor-contract/pending-signature')
      .then(res => { if (res.data && !document.fullscreenElement) { setIncoming(res.data); playSound('task'); } })
      .catch(() => {});

    const socket = getSocket();
    if (!socket) return;
    const onNew = (payload) => {
      if (document.fullscreenElement) return; // 생산전광판 전체화면 중에는 방해하지 않음
      setIncoming(payload);
      playSound('task');
    };
    socket.on('hr:labor-contract:sign-request', onNew);
    return () => socket.off('hr:labor-contract:sign-request', onNew);
  }, [user]);

  if (!incoming) return null;

  // 서명하기 — 계정관리(마이페이지)로 이동한다. 예전에는 여기서 navigate만 하고 끝나서,
  // 근로자가 마이페이지 화면에서 다시 "📝 근로계약서" 버튼을 한 번 더 눌러야 근로계약서
  // 목록 모달이 열렸다(요청사항: "모달창에 서명하기를 누르면 바로 계정관리 - 근로계약서
  // 항목이 모달창으로 나타남"). HrInfoRequestAlert.js의 openHrCard 패턴과 동일하게, 이동과
  // 동시에 모달을 자동으로 열라는 신호를 state로 함께 넘긴다(MyPage.js가 이 신호를 받아
  // showLaborContractCombinedModal을 바로 연다).
  const goSign = () => {
    setIncoming(null);
    navigate('/mypage', { state: { openLaborContract: true } });
  };

  const handleClose = () => setIncoming(null);

  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', zIndex:3000,
      display:'flex', alignItems:'center', justifyContent:'center' }}
      onClick={handleClose}>
      <div style={{ background:'#fff', borderRadius:14, width:400, maxWidth:'90vw', padding:'26px 24px 22px' }}
        onClick={e => e.stopPropagation()}>
        <div style={{ fontSize:12.5, fontWeight:700, color:'#7c3aed', marginBottom:8 }}>
          ✍️ 근로계약서 서명요청이 도착했습니다
        </div>
        <div style={{ fontSize:16.5, fontWeight:700, color:'#1a1a1a', marginBottom:8 }}>
          근로계약서에 전자서명을 진행해 주세요
        </div>
        <div style={{ fontSize:13, color:'#666', marginBottom:4 }}>
          요청자 {incoming.requested_by || '-'}
        </div>
        <div style={{ display:'flex', gap:8, marginTop:20 }}>
          <button onClick={goSign}
            style={{ flex:1, padding:'11px', background:'#7c3aed', color:'#fff', border:'none',
              borderRadius:8, fontSize:13, fontWeight:700, cursor:'pointer' }}>
            서명하러 가기
          </button>
          <button onClick={handleClose}
            style={{ flex:1, padding:'11px', background:'#fff', color:'#555', border:'1px solid #ddd',
              borderRadius:8, fontSize:13, fontWeight:600, cursor:'pointer' }}>
            닫기
          </button>
        </div>
      </div>
    </div>
  );
}
